import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import {
  ClientsSection,
  LogoContainer,
  InfiniteScrollWrapper,
  LogoScroller,
  LogoItem
} from "./ClientsStyles";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

export default function Clients({ data = {} }) {
  const { heading = "Our Clients", logos = [] } = data;
  const clientsRef = useRef(null);
  const clientsControls = useAnimation();
  const clientsInView = useInView(clientsRef, { once: true });

  React.useEffect(() => {
    if (clientsInView) clientsControls.start("visible");
  }, [clientsInView, clientsControls]);

  return (
    <ClientsSection ref={clientsRef}>
      <motion.h3 initial="hidden" animate={clientsControls} variants={fadeInUp}>
        {heading}
      </motion.h3>

      <LogoContainer initial="hidden" animate={clientsControls} variants={fadeInUp}>
        <InfiniteScrollWrapper>
          <LogoScroller>
            {[1, 2, 3, 4, 5].map((set) => (
              <React.Fragment key={`set-${set}`}>
                {logos.map((logoUrl, idx) => (
                  <LogoItem
                    key={`${set}-${idx}`}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: set * 0.1 + idx * 0.05 }}
                    whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                  >
                    <img src={logoUrl} alt="Client" />
                  </LogoItem>
                ))}
              </React.Fragment>
            ))}
          </LogoScroller>
        </InfiniteScrollWrapper>
      </LogoContainer>
    </ClientsSection>
  );
}
